// extracted by mini-css-extract-plugin
export default {"bold":"navItems_bold__yhMXG","dropDownHeader":"navItems_dropDownHeader__1Z0VA","linkWrapper":"navItems_linkWrapper__q6nzr"};